import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import React from "react";
import Typography from "@mui/material/Typography";
import { useLayoutContext } from "@ntg/component-library/contexts";
import { useEffect } from "react";
import BoatTypeToolbar from "./BoatTypeToolbar";

const title = ("Boat Type Search").toUpperCase();

export default function BoatTypeSearch() {
    const { SetSecondaryHeader, SetPrimaryTitle } = useLayoutContext();
    const [searchTerm, setSearchTerm] = React.useState<string>("");

    useEffect(() => {
        SetPrimaryTitle(title);
        SetSecondaryHeader(
            <BoatTypeToolbar
                SearchTerm={searchTerm}
                key="BoatTypeToolbar"
                onValueChange={function (value: string): void {
                    setSearchTerm(value);
                }}
            />
        );

        return () => {
            SetPrimaryTitle("");
            SetSecondaryHeader(null);
        };
    }, [SetPrimaryTitle, SetSecondaryHeader, searchTerm]);

    return (
        <Container>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <Card>
                        <Typography sx={{ paddingLeft: "16px" }} variant="body1">
                            Boat Type Search Component
                        </Typography>
                        {searchTerm}
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}